// Vánoce 2026 homepage hero slider: cross-fades slides, auto-advances every 6 s,
// restarts the countdown on any manual click, and stays still for reduced-motion users.
// The dots are story-style progress bars: past slides full, the active one fills over the same 6 s.
(function () {
  var root = document.querySelector('[data-x26-slider]');
  if (!root) return;
  var slides = root.querySelectorAll('.x26-slide');
  var dots = root.querySelectorAll('.x26-dot');
  var current = 0;
  var timer = null;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function restart() {
    clearInterval(timer);
    if (reduced) return;
    timer = setInterval(function () { go(current + 1); }, 6000);
  }

  function go(k) {
    current = (k + slides.length) % slides.length;
    slides.forEach(function (el, j) {
      el.classList.toggle('is-active', j === current);
      el.setAttribute('aria-hidden', j === current ? 'false' : 'true');
    });
    // Drop the active class first and force a reflow, so the fill animation restarts even on the same dot.
    dots.forEach(function (el) { el.classList.remove('is-active'); });
    void root.offsetWidth;
    dots.forEach(function (el, j) {
      el.classList.toggle('is-active', j === current);
      el.classList.toggle('is-done', j < current);
      el.setAttribute('aria-current', j === current ? 'true' : 'false');
    });
  }

  root.querySelector('[data-x26-prev]').addEventListener('click', function () { go(current - 1); restart(); });
  root.querySelector('[data-x26-next]').addEventListener('click', function () { go(current + 1); restart(); });
  dots.forEach(function (el, j) {
    el.addEventListener('click', function () { go(j); restart(); });
  });

  // Phones hide the arrows, so a horizontal swipe on the photo changes the slide; vertical moves still scroll the page.
  var stack = root.querySelector('.x26-stack');
  var startX = null;
  var startY = 0;
  stack.addEventListener('touchstart', function (e) {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }, { passive: true });
  stack.addEventListener('touchend', function (e) {
    if (startX === null) return;
    var dx = e.changedTouches[0].clientX - startX;
    var dy = e.changedTouches[0].clientY - startY;
    startX = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { go(current + (dx < 0 ? 1 : -1)); restart(); }
  }, { passive: true });
  restart();
})();

// Sections below the hero fade up as they scroll into view; cards inside a row follow one after another.
// Content stays visible without JS, without IntersectionObserver and for reduced-motion users.
(function () {
  var page = document.querySelector('.x26');
  if (!page || !('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var blocks = page.querySelectorAll('.x26-rv');
  blocks.forEach(function (block) {
    block.querySelectorAll('.x26-recip-grid>*,.x26-prod-grid>*,.x26-step-grid>*,.x26-rev-grid>*').forEach(function (card, j) {
      card.style.transitionDelay = Math.min(j, 6) * 70 + 'ms';
    });
  });
  var seen = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('x26-in');
      seen.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
  page.classList.add('x26-js');
  blocks.forEach(function (block) { seen.observe(block); });
})();
